<template>
  <div>
  <v-container fluid>

        <div class="display-1 font-weight-medium mt-4">
          Help
        </div>

        <Basics></Basics>
        <Payments></Payments>
        <Delivery></Delivery>
        <SiteSetup></SiteSetup>
        <AccountSetup></AccountSetup>
        <SellerSettings></SellerSettings>
        <ReturnToDashboard></ReturnToDashboard>
</v-container>

</div>
</template>

<script>
import {mapState} from 'vuex'

import Basics from './Basics'
import Payments from './Payments'
import Delivery from './Delivery'
import SiteSetup from './SiteSetup'
import AccountSetup from './AccountSetup'
import SellerSettings from './SellerSettings'
import ReturnToDashboard from '../ReturnToDashboard'

export default {
  components: {
    Basics, Delivery, Payments, SiteSetup, AccountSetup, SellerSettings, ReturnToDashboard
  },
  data () {
    return {
      showWhy: false
    }
  },
  computed: {
    ...mapState({

    })
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

</style>
